@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';
@import '../../../constants/spacing.module.less';

.left-side {
  min-height: 500px;
  padding: @space-16;
  gap: @space-8;

  .terms-checkbox {
    height: unset;
  }

  .terms-container {
    display: flex;
    flex-direction: column;
    padding-left: @space-24;
    gap: @space-4;
  }
  .optional {
    margin-left: @space-4;
    font-weight: @normal;
    color: var(--grey-600);
  }
  .disclaimer {
    margin: @space-4 @space-0 @space-0 22px;
    color: var(--grey-600);
    font-size: 12px;
    line-height: 15px;
  }
}

.right-side {
  padding: @space-16;
  gap: @space-16;

  .right-header {
    gap: @space-8;
  }
}

.external-link-icon {
  fill: var(--primary--link--fill-color--2);
  width: 12px;
  margin-left: 6px;
}

.provider-row {
  gap: @space-8;
}

.label-provider-logo {
  height: 24px;
  width: 24px;
  min-width: 30px;

  > img,
  > svg {
    height: 100%;
    width: 100%;
  }
}

.modal-header {
  font-size: 16px;
  color: var(--default--text-color--16);
  background-color: var(--grey-200);
  border: 1px solid var(--grey-400);
  box-shadow: none;
}

.modal-footer {
  background-color: var(--grey-200);
  border: 1px solid var(--grey-400);
}

.body-container {
  display: flex;
  flex-direction: row;
  width: 780px;
}

.right-side-modal {
  flex-basis: 40%;
  border-left: 1px solid var(--grey-400);
  background-color: var(--default--background-color--1);
}

.left-side-modal {
  flex-basis: 60%;
  background-color: var(--white);
}

.auto-apply-insurance {
  margin-top: @space-48;
}
